<div class="modal__header">
	<h2 class="title" id="modal__title">Change flight with extras</h2>
	<div class="modal__header-actions">
		<button aria-label="Close dialog" (click)="closeModal()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
		</button>
	</div>
</div>
<div class="modal__body sl--scrollable">
	You are about to change a flight with extras associated.<br>
	If you choose to continue changing the flight, the extras will be discarded. You will be able to add them back to the new flight.<br>

	<span class="bold">Are you sure you want to continue changing this flight?</span>
</div>
<div class="modal__footer">
	<div class="modal__footer-action negative-action"><button class="button button--small" (click)="closeModal()">Cancel</button></div>
	<div class="modal__footer-action positive-action"><button (click)="discardExtras()" class="button button--small button-secondary">Choose new flight</button></div>
</div>
